export default __webpack_public_path__ + "static/media/talk.b5c242da.jpeg";